import { useField } from "formik"
import { MultiSelectDropdown } from "./MultiSelectDropdown"

/* Formik wrapper component for the multi-select.
   This component uses Formik's useField hook to connect the
   custom multi-select to Formik's state and validation.
*/
export const FormikMultiSelectDropdown: React.FC<{
  name: string
  options: { value: string; label: string }[]
  placeholder: string
}> = ({ name, options, placeholder }) => {
  const [field, meta, helpers] = useField<string[]>(name)
  const { value } = field
  const { setValue } = helpers

  return (
    <div>
      <MultiSelectDropdown options={options} selected={value || []} onChange={setValue} placeholder={placeholder} />
      {/* {meta.touched && meta.error ? <div style={{ color: "red", marginTop: "0.5rem" }}>{meta.error}</div> : null} */}
    </div>
  )
}
